export default __webpack_public_path__ + "static/media/awn2.cd130beb.svg";